import classnames from 'classnames';

import styles from './bulleted-list.module.css';

type Bullet = React.ReactNode | string;

interface Props {
    bullets: ReadonlyArray<Bullet>;
    size?: 'normal' | 'big' | 'small';
    greyBullets?: boolean;
    marginBottom?: number;
    variant?: 'errors' | 'purple';
    lessSpacing?: boolean;
}

export function BulletedList(props: Props) {
    const {size = 'normal'} = props;

    const listStyle = classnames({
        [styles['bulleted-list--small']]: size === 'small',
        [styles['bulleted-list--normal']]: size === 'normal',
        [styles['bulleted-list--big']]: size === 'big',
    });

    const itemStyle = classnames({
        [styles['list-item--small']]: size === 'small',
        [styles['list-item--normal']]: size === 'normal',
        [styles['list-item--big']]: size === 'big',
        [styles['list-item--grey']]: props.greyBullets,
        [styles['list-item--errors']]: props.variant === 'errors',
        [styles['list-item--purple']]: props.variant === 'purple',
        [styles['list-item--less-spacing']]: props.lessSpacing,
    });

    const marginBottom = typeof props.marginBottom === 'number' ? props.marginBottom : 32;

    return (
        <ul style={{marginBottom: `${marginBottom}px`}} className={listStyle}>
            {props.bullets.map((bullet, index) => {
                return (
                    <li key={index} className={itemStyle}>
                        {bullet}
                    </li>
                );
            })}
        </ul>
    );
}
